import { Box, Loader } from '@wix/design-system';
import React from 'react';
import s from './InitialLoader.scss';
export function InitialLoader() {
  return /*#__PURE__*/React.createElement(Box, {
    className: s.container,
    direction: "vertical",
    height: "100%",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Loader, null));
}
//# sourceMappingURL=InitialLoader.js.map